import { createContext, useContext } from 'react';

const TabAdapterContext = createContext<unknown | null>(null);

export const TabAdapterProvider = <T,>({
  adapter,
  children,
}: {
  adapter: T;
  children: React.ReactNode;
}) => <TabAdapterContext.Provider value={adapter}>{children}</TabAdapterContext.Provider>;

export const useTabAdapter = <T,>(): T => {
  const adapter = useContext(TabAdapterContext);
  if (!adapter) {
    throw new Error('useTabAdapter must be used within TabAdapterProvider');
  }
  return adapter as T;
};
